import React from "react";
import LegalLayout from "./LegalLayout";

const FairPracticeCode = () => (
  <LegalLayout
    title="Fair Practice Code"
    subtitle="Pawansut Holdings Limited — RBI guidelines for fair dealing"
  >
    <p className="last-updated">Last updated: February 2025</p>
    <p className="intro">
      Pawansut Holdings Limited has adopted this Fair Practice Code (&quot;FPC&quot;) in
      line with the Reserve Bank of India&apos;s guidelines for Non-Banking Financial
      Companies. The Code sets out our commitment to transparency, fair
      treatment, and ethical conduct in our dealings with borrowers and
      customers.
    </p>

    <section>
      <h2>1. Applications and Processing</h2>
      <p>
        We provide clear information about our loan products, including
        eligibility, interest rates, fees, and tenure. Application forms and
        supporting documents required are clearly stated. We process
        applications in a non-discriminatory manner and within the timeframes we
        communicate.
      </p>
    </section>

    <section>
      <h2>2. Loan Appraisal and Terms</h2>
      <p>
        Loan appraisal is based on our internal policies and applicable
        regulations. The sanction letter and loan agreement set out the
        principal amount, rate of interest, tenure, EMI, and all applicable
        charges in clear terms. We do not charge any hidden fees; all costs are
        disclosed upfront.
      </p>
    </section>

    <section>
      <h2>3. Disbursement</h2>
      <p>
        Disbursement is made as per the sanction letter and after compliance
        with documentation and other conditions. Any change in terms before
        disbursement is communicated in writing, and the customer&apos;s consent is
        obtained where required.
      </p>
    </section>

    <section>
      <h2>4. Post-Disbursement Service</h2>
      <p>
        We provide periodic statements and respond to queries in a timely
        manner. Customers can obtain details of their account, outstanding
        balance, and interest applied. We give notice before changing interest
        rates or other terms in line with the loan agreement and RBI guidelines.
      </p>
    </section>

    <section>
      <h2>5. Recovery and Collection</h2>
      <p>
        Our recovery and collection practices are in line with our Recovery
        Policy and RBI directives. We do not resort to undue harassment,
        intimidation, or unfair means. Recovery agents and staff are trained to
        follow the Fair Practice Code and applicable laws.
      </p>
    </section>

    <section>
      <h2>6. Grievance Redressal</h2>
      <p>
        We have a Grievance Redressal Policy and a designated Grievance
        Redressal Officer. Complaints are acknowledged and redressed within the
        timelines prescribed. Escalation to the RBI Ombudsman is available where
        applicable.
      </p>
    </section>

    <section>
      <h2>7. Confidentiality</h2>
      <p>
        We treat customer information as confidential and disclose it only as
        permitted by law, including to credit bureaus and regulators. Our
        Privacy Policy explains how we collect, use, and protect your data.
      </p>
    </section>

    <section>
      <h2>8. Avoidance of Coercion</h2>
      <p>
        We do not force customers to avail of additional products or services
        as a condition for sanctioning a loan. Insurance or other add-ons, if
        any, are offered with clear disclosure and optional acceptance.
      </p>
    </section>

    <section>
      <h2>9. Review</h2>
      <p>
        This Fair Practice Code is reviewed periodically and updated to align
        with RBI guidelines and our commitment to fair and transparent
        practices. For a copy of the Code or any clarification, please contact
        us or refer to our website.
      </p>
    </section>
  </LegalLayout>
);

export default FairPracticeCode;
